/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum CurrencyCode {
  Usd = "USD",
  Cad = "CAD",
}

export function instanceOfCurrencyCode(value: any): boolean {
  for (const key in CurrencyCode) {
    if (Object.prototype.hasOwnProperty.call(CurrencyCode, key)) {
      if (CurrencyCode[key as keyof typeof CurrencyCode] === value) {
        return true;
      }
    }
  }
  return false;
}

export function CurrencyCodeFromJSON(json: any): CurrencyCode {
  return CurrencyCodeFromJSONTyped(json, false);
}

export function CurrencyCodeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CurrencyCode {
  return json as CurrencyCode;
}

export function CurrencyCodeToJSON(value?: CurrencyCode | null): any {
  return value as any;
}

export function CurrencyCodeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): CurrencyCode {
  return value as CurrencyCode;
}
